import { Image, Text } from "@mantine/core";
import { useRef } from "react";

interface ISkinAndChampionCardProps {
  name: string;
  imageSrc: string;
  isSkin?: boolean;
}

const SkinAndChampionCard: React.FC<ISkinAndChampionCardProps> = ({
  name,
  imageSrc,
  isSkin = false,
}) => {
  const textRef = useRef<HTMLParagraphElement>(null);

  const textOverflowClasses = [
    "break-keep",
    "rounded",
    "z-10",
    "bg-primary-lighter",
    "w-auto",
    "overflow-visible",
  ];

  const handleActivateAnimation = () => {
    if (!textRef.current) return;
    textRef.current.classList.add(...textOverflowClasses);

    // Remove the class after 2 seconds
    setTimeout(() => {
      if (!textRef.current) return;

      textRef.current.classList.remove(...textOverflowClasses);
    }, 2000);
  };

  const cardText = (name: string) => (
    <Text
      ref={textRef}
      className={
        "absolute mt-1 w-[65px] truncate p-1 text-primary-white " +
        "group-hover:z-10 group-hover:w-auto group-hover:overflow-visible group-hover:break-keep group-hover:rounded group-hover:bg-primary-lighter"
      }
    >
      {name}
    </Text>
  );

  const cardAvatarChampion = (name: string, imageSrc: string) => {
    return (
      <div
        className="group relative pb-8"
        onMouseDown={handleActivateAnimation}
        onTouchStart={handleActivateAnimation}
      >
        <div className="ranked-avatar relative size-[65px]">
          <Image
            className="rounded-[7px]"
            fit="cover"
            h={"auto"}
            src={imageSrc}
            w={"100%"}
          />
        </div>
        {cardText(name)}
      </div>
    );
  };

  const cardAvatarSkin = (name: string, imageSrc: string) => {
    return (
      <div
        className="group relative mb-8"
        onMouseDown={handleActivateAnimation}
        onTouchStart={handleActivateAnimation}
      >
        <div className="'] h-[150px] w-[85px] after:absolute after:top-0 after:block after:h-[150px] after:w-[85px] after:shadow-[inset_0px_0px_15px_10px_#000000] after:content-['">
          <Image
            className="rounded-[7px]"
            fit="cover"
            h={"100%"}
            src={imageSrc}
            w={"100%"}
          />
        </div>
        {cardText(name)}
      </div>
    );
  };

  if (isSkin) {
    return cardAvatarSkin(name, imageSrc);
  }

  return cardAvatarChampion(name, imageSrc);
};

export default SkinAndChampionCard;
